/**
 * 首页路由
 * 2017-12-6
 */
"use strict";
angular.module("documentDetailRouter", ["documentDetailModule"]).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("documentdetail", {
        url: "/documentDetail?articleId&type&channelId&isReview",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="view_body backstageBgcolor">' +
                    '<div class="" ui-view="main"></div>' +
                    '</div>'
            },
            "header@documentdetail": {
                templateUrl: 'header/backstageHeader_tpl.html',
                controller: 'backstageHeaderCtrl'
            },
            "main@documentdetail": {
                templateUrl: "./main/backstage/pgcManage/documentDetail/documentDetail_tpl.html",
                controller: "documentDetailCtrl"
            }
        }
    });
}]);